import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';

import { Modal } from 'office-ui-fabric-react/lib/Modal';
import {
  DetailsList,
  Selection,
  DetailsListLayoutMode,
} from 'office-ui-fabric-react/lib/DetailsList';

import { localizable } from 'components/Localization';
import Money from 'components/Money';

import './style.css';

const byDefaultDoNothing = () => { };
const columns = (t, onClick = byDefaultDoNothing) => [
  {
    key: 'name',
    name: t('Customer name'),
    fieldName: 'name',
    minWidth: 150,
    maxWidth: 400,
    onColumnClick: onClick,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'status',
    name: t('Status'),
    fieldName: 'status',
    minWidth: 100,
    maxWidth: 150,
    onColumnClick: onClick,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'createdAt',
    name: t('Submitted on'),
    fieldName: 'createdAt',
    minWidth: 100,
    maxWidth: 150,
    onColumnClick: onClick,
    isSorted: true,
    isSortedDescending: true,
  },
  {
    key: 'value',
    name: t('Bid amount'),
    fieldName: 'value',
    minWidth: 100,
    maxWidth: 150,
    onColumnClick: onClick,
    isSorted: false,
    isSortedDescending: false,
  },
];

@inject('app')
@localizable
@observer
class BiddingSection extends Component {
  @observable columns = [];

  constructor(props) {
    super(props);
    this.selection = new Selection({
      onSelectionChanged: this.handleSelectionChanged,
    });
    this.columns = columns(props.t, this.handleColumnHeaderClick);
  }

  handleRenderItemColumn = (item, index, column) => {
    const { t } = this.props;
    const content = item[column.fieldName];
    switch (column.key) {
      case 'createdAt':
        return (
          <span>{content ? content.toFormatedDateString('ll LT') : ''}</span>
        );
      case 'value':
        return (
          <span
            style={{ color: item.redButtonPriceFlag ? '#dc1c2e' : 'inherit' }}
          >
            {content < 0 && t('hidden')}
            {content >= 0 && (
              <Money
                value={content}
                currency={this.props.app.currency.code}
                locale={this.props.intl.locale}
              />
            )}
          </span>
        );
      default:
        return <span>{content}</span>;
    }
  };

  render() {
    const {
      store: { vm },
      store,
      t,
    } = this.props;
    const { closePanel } = this.props;
    return (
      <Modal
        isOpen={true}
        onDismiss={closePanel}
        isBlocking={false}
        containerClassName="history--modal"
      >
        <div
          className="clearfix history--container"
          tabIndex="0"
          style={{ height: '100%' }}
        >
          <div>
            {t('The next minimum offer')}:{' '}
            <Money
              value={vm.askingPrice}
              currency={this.props.app.currency.code}
              locale={this.props.intl.locale}
            />
          </div>
          <div>
            {t('The highest offer')}:{' '}
            <Money
              value={vm.highestBidValue}
              currency={this.props.app.currency.code}
              locale={this.props.intl.locale}
            />
          </div>
          <div>
            {t('Highest bidder')}: {store.highestBidder}
          </div>
          <div>
            {t('Round opens on')}:{' '}
            {store.offers.root.round.definition.createdAt.toFormatedDateString()}
          </div>
          {vm.history && vm.history.length > 0 && (
            <DetailsList
              columns={this.columns}
              items={store.history}
              selectionMode={1}
              checkboxVisibility={0}
              layoutMode={DetailsListLayoutMode.justified}
              onRenderItemColumn={this.handleRenderItemColumn}
            />
          )}
        </div>
      </Modal>
    );
  }
}

export default BiddingSection;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/BiddingSection/index.jsx